import axios from 'axios'
import dayjs from 'dayjs'
import { createApp } from 'vue'
import { numberWithCommas } from '~/js/helpers'
import { sendYappliId } from '~/js/yappli'

const CLASS_NAME = 'js-memberCard'

document.addEventListener('DOMContentLoaded', async () => {
  const elementsMemberCard = document.getElementsByClassName(CLASS_NAME)
  if (!elementsMemberCard.length) return

  Array.from(elementsMemberCard).forEach(async (element) => {
    const { baseUrl, customerId, customerCode, hashedCustomerId } =
      element.dataset
    createApp({
      name: 'SnippetsMemberCard',
      data() {
        return {
          hasError: false,
          isLoading: true,
          expiration: '',
          textTotalPoint: '',
          textExpirationDate: '',
          pointsToNextStage: '',
        }
      },
      async created() {
        await this.fetchCustomerPoint()
        sendYappliId({ registeredId: customerId, token: customerCode })
      },
      methods: {
        async fetchCustomerPoint() {
          this.isLoading = true
          this.hasError = false
          try {
            const { data } = await axios.get(`${baseUrl}/customer/point`, {
              withCredentials: true,
              params: {
                id: customerId,
                h: hashedCustomerId,
              },
            })
            const { totalPoint, pointsToNextStage, expiration } = data
            this.textTotalPoint = numberWithCommas(totalPoint)
            this.expiration = expiration
            this.textExpirationDate = expiration
              ? dayjs(expiration).format('YYYY年M月D日')
              : ''
            this.pointsToNextStage = pointsToNextStage
          } catch (error) {
            console.error(error)
            this.hasError = true
          }
          this.isLoading = false
        },
      },
    }).mount(element)
  })
})
